import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hoyChile, primerDiaMesChile } from '../../services/utils';

const ReporteHistorico = () => {
    const hoy = hoyChile();
    const primerDiaMes = primerDiaMesChile();

    const [filtros, setFiltros] = useState({ inicio: primerDiaMes, fin: hoy });
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    // =========================================================================
    // 🚀 FUNCIÓN MAESTRA DE CARGA (A PRUEBA DE BALAS)
    // =========================================================================
    const cargarReporte = async () => {
        console.log("🔥 BOTON PRESIONADO! Iniciando petición al backend...");
        setLoading(true);
        
        try {
            const token = localStorage.getItem("token");
            console.log("🔑 Token obtenido:", token ? "SI" : "NO (Peligro de 403/401)");

            // Limpiamos la URL por si hay slash doble (//) o falta uno
            const baseUrl = config.api_url.endsWith('/') ? config.api_url.slice(0, -1) : config.api_url;
            const url = `${baseUrl}/api/reportes/historico?inicio=${filtros.inicio}&fin=${filtros.fin}`;
            
            console.log("🚀 Disparando Fetch hacia:", url);

            const res = await fetch(url, {
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    'token': token 
                }
            });

            console.log("📥 Respuesta recibida. Status HTTP:", res.status);

            // Si el servidor manda error (404, 500, etc)
            if (!res.ok) {
                const errorText = await res.text();
                throw new Error(`Error del Servidor (${res.status}): ${errorText}`);
            }
            
            const json = await res.json();
            console.log("✅ JSON Parseado con éxito:", json);
            
            // Verificamos la estructura que armamos en Python
            if (json.status === 'success') {
                setData(json);
                toast.success("Reporte generado correctamente");
            } else {
                throw new Error(json.message || "El backend devolvió un error desconocido");
            }
            
        } catch (error) {
            console.error("💥 ERROR CAPTURADO EN REACT:", error);
            toast.error(error.message);
        } finally {
            setLoading(false);
            console.log("🏁 Proceso terminado. Loading apagado.");
        }
    };

    // =========================================================================
    // ⚙️ EFECTO INICIAL (Se ejecuta 1 sola vez al abrir la pantalla)
    // =========================================================================
    useEffect(() => {
        console.log("⚙️ Componente Montado. Ejecutando carga inicial...");
        cargarReporte();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // =========================================================================
    // 🧮 FUNCIONES DE FORMATEO Y CÁLCULO SEGURO
    // =========================================================================
    const formatCur = (val) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(Number(val) || 0);

    // Evitamos que explote si data es null (Reemplazo de Optional Chaining)
    const totales = (data && data.totales) ? data.totales : { total_ventas: 0, total_pedidos: 0 };
    const dias = (data && data.ventas_por_dia) ? data.ventas_por_dia : [];
    
    // Buscar el día récord para calcular el 100% de la barra de progreso
    const maxVentaDia = dias.length > 0 ? Math.max(...dias.map(d => Number(d.total_dia))) : 0;
    
    // Ticket Promedio (Evitar división por cero)
    const ticketPromedio = totales.total_pedidos > 0 ? (totales.total_ventas / totales.total_pedidos) : 0;

    return (
        <div className="bg-light min-vh-100 p-4">
            <ToastContainer position="top-right" autoClose={4000} />
            <div className="container" style={{ maxWidth: '1000px' }}>
                
                {/* -----------------------------------------------------------------
                    1. CABECERA Y FILTROS 
                ------------------------------------------------------------------ */}
                <div className="card shadow-sm border-0 rounded-lg p-4 mb-4">
                    <h2 className="h4 font-weight-bold text-dark mb-4">
                        <i className="fas fa-chart-line text-primary mr-2"></i> Historial de Ventas / Pedidos
                    </h2>
                    
                    <div className="row align-items-end">
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="small font-weight-bold text-muted">Fecha Desde:</label>
                            <input 
                                type="date" 
                                className="form-control bg-light border-0 py-2" 
                                value={filtros.inicio} 
                                onChange={e => setFiltros({...filtros, inicio: e.target.value})} 
                            />
                        </div>
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="small font-weight-bold text-muted">Fecha Hasta:</label>
                            <input 
                                type="date" 
                                className="form-control bg-light border-0 py-2" 
                                value={filtros.fin} 
                                onChange={e => setFiltros({...filtros, fin: e.target.value})} 
                            />
                        </div>
                        <div className="col-md-4">
                            {/* 🚨 type="button" agregado para evitar submits fantasma */}
                            <button 
                                type="button"
                                className="btn btn-primary btn-block font-weight-bold shadow-sm py-2" 
                                onClick={cargarReporte} 
                                disabled={loading}
                            >
                                {loading ? (
                                    <><i className="fas fa-spinner fa-spin mr-2"></i> CARGANDO...</>
                                ) : (
                                    <><i className="fas fa-search mr-2"></i> GENERAR REPORTE</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* -----------------------------------------------------------------
                    2. TARJETAS DE RESUMEN (KPIs) 
                ------------------------------------------------------------------ */}
                <div className="row mb-4">
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-lg text-white h-100 p-4 text-center" 
                             style={{backgroundImage: 'linear-gradient(45deg, #007bff, #00d4ff)'}}>
                            <h6 className="text-uppercase mb-2 font-weight-bold">Ingresos Totales</h6>
                            <h2 className="font-weight-bold mb-0">{formatCur(totales.total_ventas)}</h2>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-lg text-white h-100 p-4 text-center" 
                             style={{backgroundImage: 'linear-gradient(45deg, #28a745, #20c997)'}}>
                            <h6 className="text-uppercase mb-2 font-weight-bold">Ventas Completadas</h6>
                            <h2 className="font-weight-bold mb-0">{totales.total_pedidos}</h2>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-lg text-white h-100 p-4 text-center" 
                             style={{backgroundImage: 'linear-gradient(45deg, #17a2b8, #6f42c1)'}}>
                            <h6 className="text-uppercase mb-2 font-weight-bold">Ticket Promedio</h6>
                            <h2 className="font-weight-bold mb-0">{formatCur(ticketPromedio)}</h2>
                        </div>
                    </div>
                </div>

                {/* -----------------------------------------------------------------
                    3. TABLA DE DETALLE DIARIO CON GRÁFICO INTEGRADO 
                ------------------------------------------------------------------ */}
                <div className="card shadow-sm border-0 rounded-lg bg-white overflow-hidden">
                    <div className="card-header bg-white border-bottom py-3">
                        <h6 className="font-weight-bold m-0 text-muted text-uppercase">Desglose Día por Día</h6>
                    </div>
                    <div className="table-responsive">
                        <table className="table mb-0 table-hover">
                            <thead className="thead-light text-uppercase small">
                                <tr>
                                    <th className="py-3 pl-4">Fecha</th>
                                    <th className="py-3 text-center">Nº Ventas / Pedidos</th>
                                    <th className="py-3 text-right" style={{width: '200px'}}>Ingreso Diario</th>
                                    <th className="py-3 pr-4" style={{width: '30%'}}>Proporción Mensual</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dias.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center py-5 text-muted font-italic">
                                            No hay ventas registradas en las fechas seleccionadas.
                                        </td>
                                    </tr>
                                ) : dias.map((dia, idx) => {
                                    const porcentaje = maxVentaDia > 0 ? (Number(dia.total_dia) / maxVentaDia) * 100 : 0;
                                    
                                    // Arreglo de zona horaria para que no se corra un día atrás
                                    const fechaObj = new Date(dia.fecha);
                                    fechaObj.setMinutes(fechaObj.getMinutes() + fechaObj.getTimezoneOffset()); 

                                    return (
                                        <tr key={idx}>
                                            <td className="align-middle font-weight-bold text-dark pl-4">
                                                <i className="far fa-calendar-alt text-muted mr-2"></i>
                                                {fechaObj.toLocaleDateString('es-CL', { weekday: 'short', day: '2-digit', month: 'short' }).toUpperCase()}
                                            </td>
                                            <td className="align-middle text-center font-weight-bold text-muted h5 mb-0">
                                                {dia.cantidad_pedidos}
                                            </td>
                                            <td className="align-middle text-right font-weight-bold text-success h5 mb-0">
                                                {formatCur(dia.total_dia)}
                                            </td>
                                            <td className="align-middle pr-4">
                                                <div className="progress shadow-sm" style={{ height: '14px', borderRadius: '10px', backgroundColor: '#e9ecef' }}>
                                                    <div 
                                                        className={`progress-bar ${porcentaje === 100 ? 'bg-warning' : 'bg-primary'}`} 
                                                        role="progressbar" 
                                                        style={{ width: `${porcentaje}%`, borderRadius: '10px' }}
                                                        title={`${Math.round(porcentaje)}% del mejor día`}
                                                    ></div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .rounded-lg { border-radius: 1rem !important; }
                .progress-bar { transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1); }
                .table-hover tbody tr:hover { background-color: #f8f9fa; }
            `}</style>
        </div>
    );
};

export default ReporteHistorico;